var map = {
	"./Uptech-marker-alerts-icon-high-animal.png": 8908,
	"./Uptech-marker-alerts-icon-high-deformation.png": 9468,
	"./Uptech-marker-alerts-icon-high-electric-tower.png": 9613,
	"./Uptech-marker-alerts-icon-high-intrusion.png": 2684,
	"./Uptech-marker-alerts-icon-high-landslide.png": 6448,
	"./Uptech-marker-alerts-icon-high-leak.png": 92,
	"./Uptech-marker-alerts-icon-high-rock-falling.png": 8656,
	"./Uptech-marker-alerts-icon-high-temperature.png": 6328,
	"./Uptech-marker-alerts-icon-high-vehicle.png": 592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2504;